import { render, staticRenderFns } from "./PostListSelectable.vue?vue&type=template&id=35d310c4&scoped=true&"
import script from "./PostListSelectable.vue?vue&type=script&lang=js&"
export * from "./PostListSelectable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d310c4",
  null
  
)

export default component.exports